export default "__VITE_ASSET__bc365c77__"